import ToastError from "../../../components/molecules/ToastError"
import { getServicePackPossibilities } from "../../../core/service/BusinessLogicService"
import { isPdiRetailRoutes } from "../../../core/utils"
import { useLocalStorageServicePack } from "../../../hooks"
import { TunnelDataContext } from "../../context/TunnelDataContext"
import React, { useContext, useEffect, useState } from "react"
import toast from "react-hot-toast"

export const PackServiceContext = React.createContext(null)

export const PackServiceProvider = ({ children }) => {
  const { tunnelData } = useContext(TunnelDataContext)
  const [verifyiedPromotionCode, setVerifyiedPromotionCode] = useState(null)

  const {
    getLocalStorageServicePackObject,
    setLocalStorageServicePack: setLocalServicePack,
    remove
  } = useLocalStorageServicePack()
  const [packContext, setPackContext] = useState(getLocalStorageServicePackObject || null)
  const [selectedPack, setSelectedPack] = useState(null)

  const changePackContext = (data) => {
    setLocalServicePack({ ...getLocalStorageServicePackObject, ...packContext, ...data })
    setPackContext({ ...packContext, ...data })
  }

  const resetPackContext = (data) => {
    remove()
    setLocalServicePack(data)
    setPackContext(data)
  }

  function storeVerifyiedPromotionCode(promotionCode) {
    if (!promotionCode) return setVerifyiedPromotionCode(null)

    setVerifyiedPromotionCode({
      name: promotionCode,
      valid: null
    })
  }

  function validatePromoCode() {
    setVerifyiedPromotionCode((prev) => {
      return {
        ...prev,
        valid: true
      }
    })
  }

  function inValidatePromoCode() {
    setVerifyiedPromotionCode((prev) => {
      return {
        ...prev,
        valid: false
      }
    })
  }

  useEffect(() => {
    if (
      !window.location.pathname.includes("client") &&
      !isPdiRetailRoutes(window.location.pathname) &&
      !!tunnelData?.data?.order
    ) {
      getServicePackPossibilities(tunnelData)
        .then((response) => {
          changePackContext({ packs: response })
        })
        .catch((error) => {
          console.error("EvollisPagesLayout getServicePackPossibilities error : ", error, error?.response?.data)
          if (error?.response?.data) {
            toast.error(
              (t) => (
                <ToastError message={error?.response?.data?.message} handlePictoClick={() => toast.dismiss(t.id)} />
              ),
              {
                id: error?.response?.data?.message,
                duration: Infinity
              }
            )
          } else {
            toast.error((t) => <ToastError message={error?.message} handlePictoClick={() => toast.dismiss(t.id)} />, {
              id: error?.message,
              duration: Infinity
            })
          }
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const values = {
    packContext,
    changePackContext,
    selectedPack,
    setSelectedPack,
    resetPackContext,
    getLocalStorageServicePackObject,
    verifyiedPromotionCode,
    storeVerifyiedPromotionCode,
    validatePromoCode,
    inValidatePromoCode
  }

  return <PackServiceContext.Provider value={values}>{children}</PackServiceContext.Provider>
}
